<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-shop"></i> {{ isEdit ? '编辑门店' : '新增门店' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <el-form
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="110px"
        label-position="right"
        size="small"
      >
        <!-- Tab 选项卡 -->
        <el-tabs v-model="activeName" class="alipay-tabs">
          <!-- 基本信息 Tab -->
          <el-tab-pane label="基本信息" name="first">
            <div class="tab-content">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="门店名称" prop="name">
                    <el-input 
                      v-model="addForm.name" 
                      placeholder="请输入门店名称"
                      prefix-icon="el-icon-shop"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="门店编号" prop="contract_sn">
                    <el-input 
                      v-model="addForm.contract_sn" 
                      placeholder="请输入门店编号"
                      prefix-icon="el-icon-document"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="门店类别" prop="cat_id">
                    <el-select 
                      v-model="addForm.cat_id" 
                      placeholder="请选择门店类别"
                      clearable
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in cateMenus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="所属区域" prop="province_id">
                    <el-cascader
                      ref="cascaderAddr"
                      v-model="areaList"
                      :props="propsdata"
                      placeholder="请选择省/市/区"
                      clearable
                      style="width: 100%;"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="营业执照负责人">
                    <el-input 
                      v-model="addForm.artiperson" 
                      placeholder="请输入负责人姓名"
                      prefix-icon="el-icon-user"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="入驻时间">
                    <el-date-picker 
                      v-model="addForm.contract_start_time" 
                      type="date" 
                      placeholder="选择入驻时间"
                      value-format="yyyy-MM-dd"
                      prefix-icon="el-icon-date"
                      clearable
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="联系人">
                    <el-input 
                      v-model="addForm.cont_name" 
                      placeholder="请输入联系人"
                      prefix-icon="el-icon-user-solid"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input 
                      v-model="addForm.telephone" 
                      placeholder="请输入联系电话"
                      prefix-icon="el-icon-phone"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系手机">
                    <el-input 
                      v-model="addForm.mobile" 
                      placeholder="请输入联系手机"
                      prefix-icon="el-icon-mobile-phone"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14">
                  <el-form-item label="详细地址">
                    <el-input 
                      v-model="addForm.address" 
                      placeholder="请输入详细地址"
                      prefix-icon="el-icon-location"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="官网地址">
                    <el-input 
                      v-model="addForm.url" 
                      placeholder="请输入官网地址"
                      prefix-icon="el-icon-link"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="门店LOGO" class="image-preview-item">
                    <div class="logo-preview" @click="showImgDoc(1)">
                      <i v-if="!addForm.logo" class="el-icon-camera preview-icon"></i>
                      <el-image 
                        v-if="addForm.logo" 
                        class="preview-image" 
                        :src="addForm.logo" 
                        fit="cover"
                      ></el-image>
                      <div class="preview-tip" v-if="!addForm.logo">
                        点击上传LOGO
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="LOGO地址">
                    <el-input 
                      v-model="addForm.logo" 
                      placeholder="LOGO地址会自动生成"
                      prefix-icon="el-icon-link"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="门店图片">
                    <div class="upload-wrapper">
                      <el-upload
                        class="image-uploader"
                        drag
                        action="#"
                        :before-upload="handleBeforeUpload"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        :file-list="fileList"
                        list-type="picture"
                        :limit="9"
                        :on-exceed="handleFileExceed"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，建议尺寸 800x600，不超过2MB</div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 地址信息 Tab -->
          <el-tab-pane label="地址信息" name="second">
            <div class="tab-content">
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="map-wrapper">
                    <map-picker :formData="formData" :update="updateMap" v-model="location" />
                    <div class="map-tip">
                      <i class="el-icon-info"></i>
                      <span>点击地图选择门店位置，拖拽可调整精确位置</span>
                    </div>
                    <el-button size="small" @click="showLocation" icon="el-icon-location" class="map-btn">
                      显示当前坐标
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 店铺详情 Tab -->
          <el-tab-pane label="店铺详情" name="third">
            <div class="tab-content">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="店铺简介">
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入店铺简介"
                      v-model="addForm.service"
                      maxlength="200"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="editor-wrapper">
                    <Toolbar
                      style="border-bottom: 1px solid #e4e7ed"
                      :editor="editor"
                      :defaultConfig="toolbarConfig"
                      :mode="mode"
                    />
                    <Editor
                      style="height: 400px; overflow-y: auto;"
                      v-model="addForm.description"
                      :defaultConfig="editorConfig"
                      :mode="mode"
                      @onCreated="onCreated"
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 附件资料 Tab -->
          <el-tab-pane label="附件资料" name="fourth">
            <div class="tab-content">
              <div class="coming-soon">
                <i class="el-icon-folder-opened"></i>
                <p>附件资料功能即将上线</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">保存</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        </div>
      </el-form>

      <!-- 图片选择弹框 -->
      <eDocList 
        :formData="formData1"
        :visible.sync="visible1"
        :title="title1"
           @eventChoose="handleDocSelected"
        :closeForm="closeForm1"
      />
    </el-card>
  </div>
</template>

<script>
import MapPicker from '../common/MapPicker.vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import axios from 'axios'
import moment from 'moment'
import eDocList from "../common/eDocList"
import CryptoJS from "crypto-js"

export default {
  name: "shopForm",
  components: { MapPicker, Editor, Toolbar, eDocList },
  data() {
    return {
      formData: {},
      formData1: {},
      title1: '',
      visible1: false,
      type_img: 1,
      
      activeName: 'first',
      location: { lng: 121.4737, lat: 31.2304 },
      
      baseUrl: '/api/',
      fileList: [],
      gradeList: [],
      
      addForm: {
        service: '',
        cat_id: '',
        logo: '',
        id: '',
        artiperson: '',
        basic_name: "",
        work_status: '',
        status: '',
        name: '',
        contract_sn: '',
        contract_start_time: '',
        contract_end_time: '',
        grade_id: '',
        province_id: "",
        city_id: "",
        district_id: "",
        mobile: '',
        remark: '',
        telephone: '',
        address: '',
        cont_name: '',
        shop_id: '',
        description: '',
        shop_img: '',
        url: '',
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      },
      
      cateMenus: [],
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入店铺详情...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      mode: 'default',
      
      rules: {
        name: [
          { required: true, message: "请输入门店名称", trigger: 'blur' },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: 'blur' }
        ],
        contract_sn: [
          { max: 50, message: "长度不能超过50个字符", trigger: 'blur' }
        ]
      },
      
      areaList: [],
      isResouceone: false,
      
      propsdata: {
        lazy: true,
        lazyLoad(node, resolve) {
          setTimeout(() => {
            if (node.level == 0) {
              axios.post('/api/api/cmp.sys.Region_read_lz/findRegionList', {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: 1
              }).then((res) => {
                if (res.data.code == 200) {
                  const nodes = res.data.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                  resolve(nodes)
                }
              })
            }
            if (node.level == 1) {
              axios.post('/api/api/cmp.sys.Region_read_lz/findRegionList', {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: node.value
              }).then((res) => {
                if (res.data.code == 200) {
                  const nodes = res.data.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))
                  resolve(nodes)
                }
              })
            }
            if (node.level == 2) {
              axios.post('/api/api/cmp.sys.Region_read_lz/findRegionList', {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                parent_id: node.value
              }).then((res) => {
                if (res.data.code == 200) {
                  const nodes = res.data.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                    leaf: true,
                  }))
                  resolve(nodes)
                }
              })
            }
          }, 100)
        }
      }
    }
  },
  computed: {
    isEdit() {
      return this.addForm.id && this.addForm.id > 0
    }
  },
  mounted() {
    this.getCateMenus()
    this.getGradeList()
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.addForm.id = id
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    handleDocSelected(id, name, url) {
      console.log('选中的商家:', id, name, url)
      if (this.type_img == 1 && url ) {
        this.addForm.logo = url
        this.fileList = [{ name: name, url: url }]
      }
    //  if (this.type_img == 1 && url) {
    //     this.ruleForm.ad_code = url
    //     // 更新文件列表
    //     this.fileList = [{
    //       name: name,
    //       url: url
    //     }]
    //   }
    },
    updateMap(val) {
      console.log('map----', val)
    },
    
    getGradeList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        code: "shopGrade",
      }
      this.$axios.dicListByPid(param).then(res => {
        if (res.code == 200) {
          this.gradeList = res.data || []
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    showImgDoc(type) {
      this.type_img = type
      this.title1 = "图片选择"
      this.visible1 = true
    },
    
    closeForm1() {
      
      this.visible1 = false
    },
    
    handleFileExceed() {
      this.$message.warning('最多只能上传9张图片')
    },
    
    showLocation() {
      console.log('当前坐标:', this.location)
      this.$message.success(`当前坐标：经度 ${this.location.lng}，纬度 ${this.location.lat}`)
    },
    
    handleChangeAddress() {
      const checkedNode = this.$refs["cascaderAddr"]?.getCheckedNodes()
      if (checkedNode && checkedNode[0]) {
        const path = checkedNode[0].path
        if (path && path.length >= 1) this.addForm.province_id = path[0]
        if (path && path.length >= 2) this.addForm.city_id = path[1]
        if (path && path.length >= 3) this.addForm.district_id = path[2]
      }
    },
    
    submitForm() {
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          const params = { ...this.addForm }
          if (this.formData.lng && this.formData.lat) {
            params.lng = this.formData.lng
            params.lat = this.formData.lat
          }
          
          this.$axios.shopSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success("保存成功")
              setTimeout(() => {
                this.$router.push('/shopList')
              }, 1500)
            } else {
              this.$message.error(res.msg || "保存失败")
            }
          }).catch(error => {
            console.log(error)
            this.$message.error("保存失败")
          })
        }
      })
    },
    
    getOne() {
      const param = {
        access_token: this.addForm.access_token,
        company_id: this.addForm.company_id,
        id: this.addForm.id
      }
      this.$axios.shopOne(param).then((res) => {
        if (res.code == 200) {
          const item = res.data
          this.addForm.name = item.name
          this.addForm.cat_id = item.cat_id || ''
          this.addForm.shop_id = item.shop_id
          this.addForm.artiperson = item.artiperson
          this.addForm.service = item.service || ''
          this.addForm.province_id = item.province_id
          this.addForm.city_id = item.city_id
          this.addForm.district_id = item.district_id
          this.addForm.cont_name = item.cont_name
          this.addForm.telephone = item.telephone
          this.addForm.mobile = item.mobile
          this.addForm.address = item.address
          this.addForm.url = item.url || ''
          this.addForm.contract_sn = item.contract_sn
          this.addForm.description = item.description || ''
          this.addForm.logo = item.logo || ''
          
          if (item.province_id && item.city_id && item.district_id) {
            this.areaList = [item.province_id, item.city_id, item.district_id]
          }
          
          if (item.contract_start_time) {
            this.addForm.contract_start_time = moment(item.contract_start_time * 1000).format('YYYY-MM-DD')
          }
          
          if (this.addForm.logo) {
            this.fileList = [{
              name: this.addForm.name || '门店LOGO',
              url: this.addForm.logo
            }]
          }
        }
      })
    },
    
    async uploadFile(item) {
      const file = item.raw
      
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        return
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return
      }
      
      const file_md5 = await this.calculateMD5(file)
      const file_sha1 = await this.calculateSHA1(file)
      
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: file.size
      }
      
      this.$axios.uploadOne(param).then(res => {
        if (res.code == 200) {
          this.addForm.logo = res.data.url
          this.fileList = [{ name: res.data.name, url: res.data.url }]
          this.$message.success('图片上传成功')
        } else {
          this.uploadToOSS(file, file.name, file.size, file.name.split('.').pop(), file_md5, file_sha1)
        }
      })
    },
    
    uploadToOSS(file, fileName) {
      this.$axios.getAliJsonCmp({}).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const path = data.path || ''
        
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        
        axios.post(host, request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          const fullurl = host + '/' + res.data.filename
          this.addForm.logo = fullurl
          this.fileList = [{ name: fileName, url: fullurl }]
          this.$message.success('图片上传成功')
        }).catch(error => {
          console.log(error)
          this.$message.error('上传失败')
        })
      })
    },
    
    readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsBinaryString(file)
      })
    },
    
    async calculateMD5(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.MD5(words).toString()
      })
    },
    
    async calculateSHA1(file) {
      return this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString)
        return CryptoJS.SHA1(words).toString()
      })
    },
    
    goBack() {
      this.$router.push('/shopList')
    },
    
    handleBeforeUpload() {
      return false
    },
    
    getCateMenus() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.findShopCategoryTree(param).then(res => {
        if (res.code == 200) {
          this.cateMenus = res.data || []
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    uploadImg(file, insertFn) {
      this.$axios.getAliJsonCmp({}).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const path = data.path || ''
        
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + path + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          const fullurl = host + '/' + res.data.filename
          setTimeout(() => {
            insertFn(fullurl)
          }, 500)
          this.$message.success('图片上传成功')
        }).catch(error => {
          console.log(error)
          this.$message.error('图片上传失败')
        })
      })
    },
    
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    
    get_suffix(filename) {
      const pos = filename.lastIndexOf('.')
      return pos !== -1 ? filename.substring(pos) : ''
    },
    
    Ymdhis() {
      const date = new Date()
      return '' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + 
             date.getHours() + date.getMinutes() + date.getSeconds() + 
             Math.floor(Math.random() * 9000 + 1000)
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

.alipay-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 20px;
    background: #f8f9fc;
    border-radius: 8px;
    padding: 0 16px;
    
    .el-tabs__nav-wrap::after {
      display: none;
    }
    
    .el-tabs__item {
      font-size: 14px;
      font-weight: 500;
      padding: 0 20px;
      height: 44px;
      line-height: 44px;
      
      &.is-active {
        color: #1677ff;
      }
      
      &:hover {
        color: #4096ff;
      }
    }
    
    .el-tabs__active-bar {
      background: #1677ff;
      height: 3px;
    }
  }
}

.tab-content {
  padding: 8px 0 20px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.el-input .el-input__inner,
.el-textarea .el-textarea__inner,
.el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
  
  &:focus {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

.logo-preview {
  width: 120px;
  height: 120px;
  border: 2px dashed #e4e7ed;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fc;
  overflow: hidden;
  
  &:hover {
    border-color: #1677ff;
    background: #f0f7ff;
    
    .preview-icon {
      color: #4096ff;
    }
  }
  
  .preview-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 8px;
    transition: color 0.3s ease;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .preview-tip {
    font-size: 12px;
    color: #8c8f98;
  }
}

.upload-wrapper {
  .image-uploader .el-upload-dragger {
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    background: #fafbfc;
    width: 100%;
    height: 140px;
    
    &:hover {
      border-color: #1677ff;
      background: #f0f7ff;
    }
    
    .el-icon-upload {
      font-size: 40px;
      color: #1677ff;
      margin-top: 28px;
    }
    
    .el-upload__text {
      color: #8c8f98;
      
      em {
        color: #1677ff;
      }
    }
  }
  
  .el-upload-list__item {
    border-radius: 8px;
    transition: all 0.2s;
    
    &:hover {
      background: #f5f7fa;
    }
  }
  
  .el-upload__tip {
    font-size: 12px;
    color: #8c8f98;
    margin-top: 8px;
  }
}

.map-wrapper {
  .map-tip {
    margin: 12px 0;
    padding: 8px 12px;
    background: #e6f4ff;
    border-radius: 8px;
    color: #1677ff;
    font-size: 13px;
    
    i {
      margin-right: 8px;
    }
  }
  
  .map-btn {
    margin-top: 12px;
    border-radius: 20px;
  }
}

.editor-wrapper {
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
  
  &:focus-within {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

.coming-soon {
  text-align: center;
  padding: 80px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>

<style>
.w-e-modal {
  z-index: 999 !important;
  left: 300px !important;
  top: 300px !important;
}
</style>